class Api {
    constructor(options) {
        this._address = options.baseUrl;
        this._headers = options.headers;
    }

    _checkResponse(res) {
        if (res.ok) {
            return res.json();
        }
        return Promise.reject(`${res.status}`);
    }

    getCourses(token) {
        return fetch(`${this._address}/courses`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getProgressCourse(token, courseId) {
        return fetch(`${this._address}/get_progress/${courseId}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getRoadMap(token, courseId) {
        return fetch(`${this._address}/courses/${courseId}/`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getLesson(token, lessonId) {
        return fetch(`${this._address}/lessons/${lessonId}/`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getStep(token, stepId) {
        // CHECK
        return fetch(`${this._address}/steps/${stepId}/`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getStreams(token) {
            return fetch(`${this._address}/streams`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                // credentials: 'include',
            }).then(this._checkResponse);
        }
        //TESTS ZONE
    getTest(token, testId) {
        return fetch(`${this._address}/tests/${testId}/`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }

    startTest(token, testId) {
        return fetch(`${this._address}/tests/${testId}/check/start`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    endTest(token, testId, attemptId, time) {
        return fetch(`${this._address}/tests/${testId}/check/${attemptId}/finish`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            // credentials: 'include',
            body: JSON.stringify({
                time_spent: time,
            }),
        }).then(this._checkResponse);
    }
    checkSingleMultiSequence(token, testId, attemptId, questionId, answers) {
        return fetch(
            `${this._address}/tests/${testId}/check/${attemptId}/sing_mult_seq`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                // credentials: 'include',
                body: JSON.stringify({
                    question_id: questionId,
                    answers: answers,
                }),
            }
        ).then(this._checkResponse);
    }
    checkShortAnswer(token, testId, attemptId, questionId, answers) {
        return fetch(`${this._address}/tests/${testId}/check/${attemptId}/short`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            // credentials: 'include',
            body: JSON.stringify({
                question_id: questionId,
                answers: answers,
            }),
        }).then(this._checkResponse);
    }
    checkBlanks(token, testId, attemptId, questionId, answers) {
        return fetch(`${this._address}/tests/${testId}/check/${attemptId}/blanks`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            // credentials: 'include',
            body: JSON.stringify({
                question_id: questionId,
                answers: answers,
            }),
        }).then(this._checkResponse);
    }

    // rethink
    checkPairs(token, testId, attemptId, questionId, answers) {
        return fetch(`${this._address}/tests/${testId}/check/${attemptId}/pairs`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            // credentials: 'include',
            body: JSON.stringify({
                question_id: questionId,
                answers: answers,
            }),
        }).then(this._checkResponse);
    }
    checkEssay(token, testId, attemptId, questionId, answers) {
        return fetch(`${this._address}/tests/${testId}/check/${attemptId}/essay`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            // credentials: 'include',
            body: JSON.stringify({
                question_id: questionId,
                answers: answers,
            }),
        }).then(this._checkResponse);
    }
    checkFile(token, testId, attemptId, questionId, file, filename, third_party_url) {
            return fetch(`${this._address}/tests/${testId}/check/${attemptId}/file`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                // credentials: 'include',
                body: JSON.stringify({
                    question_id: questionId,
                    files: file,
                    filenames: filename,
                    third_party_url: third_party_url,
                }),
            }).then(this._checkResponse);
        }
        // sendAnswers(token, testId, answers, stepId, userId, time) {
        //   return fetch(`${this._address}/tests/${testId}/check/`, {
        //     method: 'POST',
        //     headers: {
        //       'Authorization': `Bearer ${token}`,
        //       'Content-Type': 'application/json',

    //     },
    //     // credentials: 'include',
    //     body: JSON.stringify({
    //       step_id: stepId,
    //       user_id: userId,
    //       time_spent: time,
    //       answers: answers,
    //     }),
    //   })
    //     .then(this._checkResponse)
    // }
    getTestResult(token, testId) {
        return fetch(`${this._address}/tests/${testId}/result/`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getTestBestResult(token, testId) {
            return fetch(`${this._address}/tests/${testId}/best_result/`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                // credentials: 'include',
            }).then(this._checkResponse);
        }
        // EXERCISE CHECK ZONE
    getExercise(token, testId) {
        return fetch(`${this._address}/exercises/${testId}/`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }

    checkExerciseSingleMultiSequence(
        token,
        testId,
        attemptId,
        questionId,
        answers
    ) {
        return fetch(
            `${this._address}/exercises/${testId}/check/${attemptId}/sing_mult_seq`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                // credentials: 'include',
                body: JSON.stringify({
                    question_id: questionId,
                    answers: answers,
                }),
            }
        ).then(this._checkResponse);
    }
    checkExerciseShortAnswer(token, testId, attemptId, questionId, answers) {
        return fetch(
            `${this._address}/exercises/${testId}/check/${attemptId}/short`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                // credentials: 'include',
                body: JSON.stringify({
                    question_id: questionId,
                    answers: answers,
                }),
            }
        ).then(this._checkResponse);
    }
    checkExerciseBlanks(token, testId, attemptId, questionId, answers) {
        return fetch(
            `${this._address}/exercises/${testId}/check/${attemptId}/blanks`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                // credentials: 'include',
                body: JSON.stringify({
                    question_id: questionId,
                    answers: answers,
                }),
            }
        ).then(this._checkResponse);
    }

    // rethink
    checkExercisePairs(token, testId, attemptId, questionId, answers) {
        return fetch(
            `${this._address}/exercises/${testId}/check/${attemptId}/pairs`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                // credentials: 'include',
                body: JSON.stringify({
                    question_id: questionId,
                    answers: answers,
                }),
            }
        ).then(this._checkResponse);
    }
    checkExerciseEssay(token, testId, attemptId, questionId, answers) {
        return fetch(
            `${this._address}/exercises/${testId}/check/${attemptId}/essay`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                // credentials: 'include',
                body: JSON.stringify({
                    question_id: questionId,
                    answers: answers,
                }),
            }
        ).then(this._checkResponse);
    }
    checkExerciseFile(token, testId, attemptId, questionId, file, filename, third_party_url) {
        return fetch(
            `${this._address}/exercises/${testId}/check/${attemptId}/file`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                // credentials: 'include',
                body: JSON.stringify({
                    question_id: questionId,
                    files: file,
                    filenames: filename,
                    third_party_url: third_party_url,
                }),
            }
        ).then(this._checkResponse);
    }

    // getBreadCrumbs(token, model, id) {
    //   return fetch(`${this._address}/breadcrumbs?model_type=${model}&model_id=${id}`, {
    //     method: 'GET',
    //     headers: {
    //       'Authorization': `Bearer ${token}`,
    //     },
    //     // credentials: 'include',
    //   })
    //     .then(this._checkResponse)
    // }
    getActualTasks(token) {
        return fetch(`${this._address}/get_actual_tasks`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getCurrentTasks(token) {
        return fetch(`${this._address}/actual/steps/`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getReportTasks(token) {
        return fetch(`${this._address}/get_report_tasks`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getMainPageStats(token) {
        return fetch(`${this._address}/profile/stats_short/`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getUser(token) {
        return fetch(`${this._address}/profile/`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    changeAvatar(token, file, filename) {
        return fetch(`${this._address}/profile/avatar/`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            // credentials: 'include',
            body: JSON.stringify({
                file: file,
                file_name: filename,
            }),
        }).then(this._checkResponse);
    }
    deleteAvatar(token) {
        return fetch(`${this._address}/profile/avatar/`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getPerformance(token) {
        return fetch(`${this._address}/stats_short/`, {
            // replaced stats/detail ???????
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getPerformanceSpecial(token, model, id) {
        return fetch(`${this._address}/stats_detail/?${model}_id=${id}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getPerformanceSorted(token, orderBy, orderType) {
        return fetch(
            `${this._address}/stats_short/?order_by=${orderBy}&order_type=${orderType}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                // credentials: 'include',
            }
        ).then(this._checkResponse);
    }

    // performance specialized

    getPerformanceSpecialSorted(token, model, id, orderBy, orderType) {
        return fetch(
            `${this._address}/stats_detail/?${model}_id=${id}&order_by=${orderBy}&order_type=${orderType}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                // credentials: 'include',
            }
        ).then(this._checkResponse);
    }
    getFilterInfo(token, model, id) {
        return fetch(`${this._address}/${model}/${id}/short/`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }

    // theme zone
    getAllLessons(token, themeId) {
        return fetch(`${this._address}/topics/${themeId}/`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }
    getCurrentTests(token, themeId) {
            return fetch(`${this._address}/stats_detail?topic_id=${themeId}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                // credentials: 'include',
            }).then(this._checkResponse);
        }
        // getTestsDone(token, themeId) {
        //   return fetch(`${this._address}/topic/${themeId}/tests`, {
        //     method: 'GET',
        //     headers: {
        //       'Authorization': `Bearer ${token}`,
        //     },
        //     // credentials: 'include',
        //   })
        //     .then(this._checkResponse)
        // }

    // current tasks page
    getAllCurrent(token) {
        return fetch(`${this._address}/actual/courses/`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
        }).then(this._checkResponse);
    }


    getConferenceRoom(token, studentId, name, roomId, roomTitle) {
        let formData = new FormData();
        formData.append(`userId`, studentId);
        formData.append(`name`, name);
        formData.append(`roomId`, roomId);
        formData.append(`roomTitle`, roomTitle);
        return fetch(`https://api.platonics.ru/meeting/student.php`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // credentials: 'include',
            body: formData,
        }).then((res) => {
            return res.text();
        });
    }

		// CALENDAR
	getEvents(token, startDate, endDate) {
			return fetch(`${this._address}/events/get_student_event`, {
				method: 'POST',
				headers: {
					Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					start_dt: startDate,
					end_dt: endDate,
				}),
			}).then(this._checkResponse);
		}

	getNotifications(token) {
			return fetch(`${this._address}/notifications`, {
				method: 'GET',
				headers: {
					Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
				}
			}).then(this._checkResponse);
		}
	readNotification(token, readedId) {
			return fetch(`${this._address}/notification_update/${readedId}`, {
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					is_read: true
				}),
			}).then(this._checkResponse);
		}

         // booking page

        getCoursesTeacher(token) {
            return fetch(`${this._address}/actual/courses_teachers`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(this._checkResponse);
        }

        getMyRequests(token) {
            return fetch(`${this._address}/get_my_booking_requests`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(this._checkResponse);
        }

        
        getTeachersData(token, teacherId, courseId) {
            // console.log(courseId);
            return fetch(`${this._address}/get_free_slots/`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    teacher_id: teacherId,
                    course_id: courseId
                }),
            }).then(this._checkResponse);
        }
        createBookingRequest(token, slotId, comment, course, teacher) {
            // console.log(slotId);
            return fetch(`${this._address}/create_booking_request`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    slot_id: slotId,
                    comment: comment,
                    course_title: course,
                    teacher_name: teacher,
                }),
            }).then(this._checkResponse)
        }
}
const api = new Api({
    // baseUrl: `http://px-dev-backend.platonics.ru:8000`,
    // baseUrl: ` https://api-dev.platonics.ru/student`,
    baseUrl: ` https://api.platonics.ru/student`,
    // baseUrl: `http://px-dev-backend-deprecated.excteam.ru`,

    headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
    },
});
export default api;
